/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VisitStatus = {
    Active: 'active',
    Ended: 'ended',
    Abandoned: 'abandoned',
} as const;
export type VisitStatus = typeof VisitStatus[keyof typeof VisitStatus];


export function instanceOfVisitStatus(value: any): boolean {
    for (const key in VisitStatus) {
        if (Object.prototype.hasOwnProperty.call(VisitStatus, key)) {
            if (VisitStatus[key as keyof typeof VisitStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VisitStatusFromJSON(json: any): VisitStatus {
    return VisitStatusFromJSONTyped(json, false);
}

export function VisitStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitStatus {
    return json as VisitStatus;
}

export function VisitStatusToJSON(value?: VisitStatus | null): any {
    return value as any;
}

export function VisitStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): VisitStatus {
    return value as VisitStatus;
}

